import React from 'react';
import { Element, StepCircle } from './Step.styles';
import { Text } from '@/components/typography';
import CheckIcon from '@/components/icons/CheckIcon/CheckIcon';
import { useStepperContext } from '@/components/stepper/context/StepperContext';

export interface StepProps {}

const Step = ({ ...props }: StepProps) => {
  const { active, steps } = useStepperContext();
  return (
    <React.Fragment>
      {steps.map((step, index) => (
        <Element key={`${index}-${step}`} active={active >= index} completed={index < active}>
          <StepCircle>{(index < active && <CheckIcon />) || index + 1}</StepCircle>
          <Text size="xs" align="center">
            {step}
          </Text>
        </Element>
      ))}
    </React.Fragment>
  );
};

export default Step;
